<template>
    <div id="about-container">
        <h1>What is Pimplr?</h1>
        <p>In short, Pimblr is like tumblr or twitter... but for porn videos only and more annonymous.</p>

        <div class="icon-cont">
            <icon icon="lightbulb" size="5x"/>
        </div>
        <h2>A new way of watching porn</h2>
        <p>The idea behind Pimblr is, that you do not have to search for porn anymore. You got it straight delivered to
            your dashbord! Every day or every hour you will find new videos from blogs you like on your dashbord, so
            just click play and enjoy!</p>


        <div class="icon-cont">
            <icon icon="question" size="5x"/>
        </div>
        <h2>How does it work</h2>
        <p>On Pimblr you can create and follow blogs. A Pimblr-blog is a collection of videos on a specific topic,
            taste, fetish or whatever. So, if you find some blogs you like, you can follow them with only one click.
            From there on, you will find the latest videos your favorite blogs postet, right on your dashboard.</p>


        <div class="icon-cont">
            <icon icon="list" size="5x"/>
        </div>
        <h2>Blog as Playlist</h2>
        <p>A Blog can also seen as a simple playlist. So your Dashboard is you personal Best-Of-Playlist! And unlike
        a usual playlist, or a board in pinterest, a blog is always growing!</p>


        <div class="icon-cont">
            <icon icon="users" size="5x"/>
        </div>
        <h2>Be part of our community</h2>
        <p>Contribute to our community is easy! You will get your first blog right with your registration, but it's
            totally up to you to use it or not. You can also create new blogs with just a few clicks. You can fill ist
            by just reblog videos you like, or by posting new videos from our supported sites, so far
            <a href="https://pornhub.com" target="_blank">PornHub</a>,
            <a href="https://xhamster.com" target="_blank">xHamster</a>
            and <a href="https://tumblr.com" target="_blank">tumblr</a>.</p>



        <h2 class="mt-5">Start now!</h2>
        <div class="mt-4 text-center big-btns">
            <router-link :to="{name:'Login'}" tag="button" class="btn btn-lg btn-outline-primary">Login</router-link>
            <router-link :to="{name:'Registration'}" tag="button" class="btn btn-lg btn-outline-primary">Register</router-link>
        </div>

    </div>
</template>

<script>

    import Icon from '../ui/Icon'

    export default {
        name: 'About',
        data() {
            return {}
        },
        methods: {},
        components:{
            Icon
        }
    }
</script>

<style lang="sass" scoped>

    @import '../../assets/sass/vars.scss'

    #about-container

        .icon-cont
            text-align: center
            margin-top: 3em
            margin-bottom: 1em
            color: $colorPrimary

        h1,h2,h3
            text-align: center
</style>



// WEBPACK FOOTER //
// src/components/layout/About.vue